import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'additionalDetails.page.title': {
    id: 'additionalDetails.page.title',
    defaultMessage: 'Additional Details | {siteName}',
    description: 'Additional details page title',
  },
  'additionalDetails.page.heading': {
    id: 'additionalDetails.page.heading',
    defaultMessage: 'Tell us a bit more about you',
    description: 'Heading on the additional details page',
  },
  'additionalDetails.page.subheading': {
    id: 'additionalDetails.page.subheading',
    defaultMessage: 'Your organisation asks for these details. You can skip for now and add them later from your account.',
    description: 'Sub-heading explaining why the additional details are collected',
  },
  'additionalDetails.submit.button': {
    id: 'additionalDetails.submit.button',
    defaultMessage: 'Save and continue',
    description: 'Label for the additional details submit button',
  },
  'additionalDetails.skip.button': {
    id: 'additionalDetails.skip.button',
    defaultMessage: 'Skip for now',
    description: 'Label for the skip link on the additional details page',
  },
  'additionalDetails.select.placeholder': {
    id: 'additionalDetails.select.placeholder',
    defaultMessage: 'Select an option',
    description: 'Placeholder option shown in a dropdown additional detail',
  },
  'additionalDetails.error.required': {
    id: 'additionalDetails.error.required',
    defaultMessage: 'This field is required.',
    description: 'Validation error shown under an unanswered required field',
  },
  'additionalDetails.error.submit': {
    id: 'additionalDetails.error.submit',
    defaultMessage: 'We could not save your details. Please try again.',
    description: 'Error shown when saving the additional details fails',
  },
});

export default messages;
